import React, { useEffect } from 'react';
import './psbienmas2024.css';
import { psbienmas2024 } from '../../json/psbienmas2024';

const Psbienmas2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Bienestar de Madres Solteras 2024"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                Que el presente Programa fortalece y vincula entre sí y con los diversos órganos de gobierno a los Colectivos Comunitarios para que a través del fomento a sus actividades promuevan el bienestar, la cohesión y capital social, el desarrollo humano y social de grupos, comunidades o regiones que viven en situación de vulnerabilidad o exclusión, así como el fortalecimiento de expresiones artesanales en el estado de Hidalgo. Desde un enfoque transversal y con perspectiva de género, el Programa busca contribuir a promover la igualdad de oportunidades y de trato entre mujeres y hombres. Por lo tanto, contribuye a dirigir los esfuerzos conjuntos para la atención de grupos de población que viven situaciones de vulnerabilidad o exclusión, propiciando su inclusión en el desarrollo social desde un enfoque de derechos.
                </p>
                <p>
                El Programa está diseñado para propiciar y fortalecer la participación de los Actores Sociales en las políticas de desarrollo social impulsadas por el Gobierno del Estado de Hidalgo y coadyuvar en la promoción de la transparencia y el combate a la corrupción en la gestión pública.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6><br />
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a mejorar las condiciones para el acceso y permanencia en el mercado laboral y en los estudios de las madres solteras que no cuenten con la prestación de cuidados infantiles, que habiten en las 12 regiones del Estado de Hidalgo, de acuerdo con el Plan Estatal de Desarrollo 2022-2028, dando prioridad a las localidades de alta y muy alta marginación, en pobreza o en los 22 municipios de Atención Prioritaria Indígena del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Madres solteras trabajadoras y madres estudiantes con hijo o hija de 0 a 4 años y 11 meses, sin acceso a los servicios de cuidado y atención infantil, de las 12 regiones del Estado de Hidalgo de acuerdo con el Plan Estatal de Desarrollo 2022-2028, en localidades de alta y muy alta marginación, en situación de pobreza o en los 22 municipios de atención prioritaria indígena, que perciban un ingreso comprobable menor a los $6,500. 00 (Seis mil quinientos pesos 00/100) de manera mensual.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El Programa “Bienestar de Madres Solteras”, priorizará la distribución equitativa de los apoyos en las 12 regiones del Estado de Hidalgo, de acuerdo con el Plan Estatal de Desarrollo 2022-2028.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Inclusión y Desarrollo<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                L. D. Ricardo Gómez Moreno: Secretario de la SEBISO
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 717 8000 Ext. 8948
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Bienestar_de_Madres_Solteras_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Bienestar_de_Madres_Solteras_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Reforma 02 de febrero de 2024</a><br />
                </li>
                </ul>

                  
                
                  <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Convocatorias</h5>
                <ul>
                  <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2024/CONV_MS_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2024/CONV_MS_OCT2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                </li>
                </ul><p></p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Consulta de folios beneficiados</h5>
                <ul>
                  <li>
                <a
                href='https://amigosdelatransformacion.com.mx/ms.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                <li>
                <a
                href='https://amigosdelatransformacion.com.mx/msoct.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                </li>
                </ul>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Estadisticas</h5>
                <ul>
                  <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/estadisticas/3erT/Est_BMS_2024_3erT.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Tercer Trimestre</a>
                </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Enlaces a los catálogos estatal y nacional</h5>
                <ul>
                  <li>
                <a
                href='https://ruts.hidalgo.gob.mx/ver/11120'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Registro Único de Trámites y Servicios (RUTS)</a>
                </li>
                <li>
                <a
                href='https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-001-A'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Catalogo Nacional de Regulaciones Trámites y Servicios (CNARTyS)</a>
                </li>
                </ul>
                </p>
                
              </div>
            </div>
            
          </div>
        </div>

      </div>    
    </div>
  );
};

export default Psbienmas2024;